import { matchesAccount, matchesAccounts } from '@/parse-and-play/utils.js'

const groupBy = (items, key) => {
  return items.reduce((acc, item) => {
    (acc[item[key]] = acc[item[key]] || []).push(item)
    return acc
  }, {})
}

class Transaction {
  constructor (attrs) {
    this.id = attrs.id
    this.comments = attrs.comments
    this.postings = attrs.postings || []
    this.date = attrs.date
    this.periodicRange = attrs.periodicRange
    this.referenceId = attrs.referenceId
    this.payee = attrs.payee
    this.status = attrs.status
    this.identityId = attrs.identityId
    this.periodicName = attrs.periodicName
    this.isStaged = attrs.isStaged || false
    this.sourceId = attrs.sourceId
    this.raw = attrs.raw
    this.amount = attrs.amount
    this.category = attrs.category
    this.hash = attrs.hash
  }

  static computeHash (t) {
    const str = `${t.date}|${t.payee}|${t.amount}|${t.sourceId}`
    let hash = 0
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i)
      hash |= 0
    }
    return hash.toString(36)
  }

  static computeComparisonHash (t) {
    let amount
    // Staged transactions have amount as string like "123.45 CAD"
    // Committed transactions have amounts in postings
    if (t.amount) {
      const match = t.amount.match(/([-\d.]+)/)
      amount = match ? parseFloat(match[1]) : 0
    } else if (t.postings && t.postings.length > 0) {
      // Fall back to first posting's amount for committed transactions
      amount = t.postings[0].amount
    } else {
      amount = 0
    }
    return `${t.date}|${amount}`
  }

  get cleared () {
    return this.status === 'cleared' || this.status === Transaction.STATUSES.CLEARED
  }

  get isIgnored () {
    return this.status === 'ignored'
  }

  // get total () {
  //   // this doesn't take currency into account
  //   return this.postings.reduce((sum, posting) => sum + posting.amount, 0)
  // }

  sum (account) {
    const summary = {}

    this.postings.forEach((posting) => {
      if (!matchesAccount(posting.account, account)) return

      if (typeof summary[posting.account] === 'undefined') {
        summary[posting.account] = {}
      }

      if (typeof summary[posting.account][posting.currency] === 'undefined') {
        summary[posting.account][posting.currency] = 0
      }

      if (typeof posting.amount !== 'undefined') {
        summary[posting.account][posting.currency] += posting.amount
      }
    })

    return summary
  }

  sumAccounts (accounts) {
    const summary = {}

    this.postings.forEach((posting) => {
      if (!matchesAccounts(posting.account, accounts)) return

      if (typeof summary[posting.account] === 'undefined') {
        summary[posting.account] = {}
      }

      if (typeof summary[posting.account][posting.currency] === 'undefined') {
        summary[posting.account][posting.currency] = 0
      }

      if (typeof posting.amount !== 'undefined') {
        summary[posting.account][posting.currency] += posting.amount
      }
    })

    return summary
  }

  getPostings (filters = []) {
    const postings = this.postings

    if (filters.length === 0) {
      return postings
    }

    const groups = groupBy(filters, 'type')

    return postings.filter((posting) => {
      for (const type in groups) {
        const typeFilters = groups[type]

        if (typeFilters.filter((f) => f.filter()(posting)).length) {
          continue
        }

        return false
      }

      return true
    })
  }
}

Transaction.STATUSES = {
  PENDING: '!',
  CLEARED: '*'
}

Transaction.STAGED_STATUSES = {
  PENDING: 'pending',
  CLEARED: 'cleared',
  IGNORED: 'ignored'
}

export default Transaction
